__turbopack_context__.v({
  "container": "OpenLetterSection-module-scss-module__6PMdya__container",
  "fade-in": "OpenLetterSection-module-scss-module__6PMdya__fade-in",
  "form": "OpenLetterSection-module-scss-module__6PMdya__form",
  "formWrapper": "OpenLetterSection-module-scss-module__6PMdya__formWrapper",
  "iconWrapper": "OpenLetterSection-module-scss-module__6PMdya__iconWrapper",
  "successBox": "OpenLetterSection-module-scss-module__6PMdya__successBox",
});
